import React from "react";
import Footer from "./Footer";
import Header from "./Header";

export const Layout = (props) => {
  return (
    <div>
      <Header />
      {props.children}
      <Footer />
    </div>
  );
};
